// Servicio para consumir productos desde archivo JSON local
import productosData from '@/config/productos.json';

// Función auxiliar para extraer docente del título o descripción
function extractDocente(titulo, descripcion) {
    // Patrones para extraer docente del título o descripción
    const patrones = [
        /con\s+([A-ZÁÉÍÓÚÑ][a-záéíóúñ\s]+)/i,
        /por\s+([A-ZÁÉÍÓÚÑ][a-záéíóúñ\s]+)/i,
        /dictado\s+por\s+([A-ZÁÉÍÓÚÑ][a-záéíóúñ\s]+)/i,
        /impartido\s+por\s+([A-ZÁÉÍÓÚÑ][a-záéíóúñ\s]+)/i
    ];

    for (const patron of patrones) {
        const match = titulo.match(patron) || descripcion.match(patron);
        if (match) {
            return match[1].trim().toUpperCase();
        }
    }

    return "DOCENTE ORSAI";
}

// Función auxiliar para extraer fecha de la descripción
function extractFecha(descripcion) {
    // Patrones para extraer fecha de la descripción
    const patrones = [
        /(\d{1,2}\/\d{1,2}\/\d{4})/,
        /(\d{1,2}\s+de\s+[a-z]+)/i,
        /(desde\s+el\s+\d{1,2}\/\d{1,2})/i,
        /(inicia\s+el\s+\d{1,2}\/\d{1,2})/i,
        /(comienza\s+el\s+\w+\s+\d{1,2})/i
    ];

    for (const patron of patrones) {
        const match = descripcion.match(patron);
        if (match) {
            return match[1];
        }
    }

    return "Próximamente";
}

// Función auxiliar para formatear precio
function formatPrice(price) {
    if (!price) return "Consultar";

    return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(price).replace('ARS', '').trim();
}

// Función para obtener todos los productos
export function getAllProductos() {
    return productosData;
}

// Función para obtener talleres específicos
export function getTalleres() {
    try {
        // Mostrar todos los productos en el orden que están en el JSON
        const talleres = productosData;

        // Transformar a formato compatible con el componente actual
        return talleres.map(producto => ({
            id: producto.id,
            slug: producto.handle?.es || producto.handle,
            docente: extractDocente(producto.title, producto.description),
            lema: producto.title,
            inicio: extractFecha(producto.description),
            precio: formatPrice(producto.price),
            precioUSD: null, // No hay precio en USD en los datos
            linkTienda: `https://talleres.orsai.org/products/${producto.handle?.es || producto.handle}`,
            urlAfiche: producto.image,
            boton: 'Reservar',
            botonInfo: null, // Para usar link directo a la tienda
            colorBoton: '#2563eb' // Azul por defecto
        }));

    } catch (error) {
        console.error('Error obteniendo talleres:', error);
        throw error;
    }
}

// Función para obtener un producto específico por ID
export function getProductoById(id) {
    return productosData.find(producto => producto.id === id);
}

// Función para obtener un producto específico por handle
export function getProductoByHandle(handle) {
    return productosData.find(producto =>
        producto.handle?.es === handle || producto.handle === handle
    );
}
